import { motion } from 'framer-motion';
import { Button } from '../../ui/button';
import { ShieldCheck, ArrowUp, ArrowDown, X } from '@phosphor-icons/react';

export const WellnessHelpModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl p-6 sm:p-8 max-w-lg w-full shadow-2xl max-h-[90vh] overflow-y-auto"
      >
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#10B981] to-[#059669] flex items-center justify-center">
              <ShieldCheck className="w-6 h-6 text-white" weight="duotone" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-[#0F172A]">Wellness Score</h3>
              <p className="text-sm text-[#64748B]">How we calculate your score</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-[#F1F5F9] hover:bg-[#E2E8F0] flex items-center justify-center"
          >
            <X className="w-4 h-4 text-[#64748B]" />
          </button>
        </div>
        
        <div className="space-y-4">
          <p className="text-[#334155] text-sm leading-relaxed">
            Your Wellness Score (0-100) is a personalized indicator that combines multiple health factors to give you an overall picture of your menopausal wellness.
          </p>
          
          <div className="bg-[#F0FDF4] rounded-xl p-4 border border-[#BBF7D0]">
            <h4 className="font-semibold text-[#166534] mb-2 flex items-center gap-2">
              <ArrowUp className="w-4 h-4" /> Factors that increase your score
            </h4>
            <ul className="text-sm text-[#166534] space-y-1">
              <li>• Regular exercise and physical activity</li>
              <li>• Good sleep quality</li>
              <li>• Non-smoker status</li>
              <li>• Healthy hormone levels (AMH, FSH, Estradiol)</li>
              <li>• Regular menstrual cycles</li>
              <li>• Stable mood</li>
            </ul>
          </div>
          
          <div className="bg-[#FEF2F2] rounded-xl p-4 border border-[#FECACA]">
            <h4 className="font-semibold text-[#991B1B] mb-2 flex items-center gap-2">
              <ArrowDown className="w-4 h-4" /> Factors that decrease your score
            </h4>
            <ul className="text-sm text-[#991B1B] space-y-1">
              <li>• Smoking (current or former)</li>
              <li>• Heavy alcohol consumption</li>
              <li>• Poor sleep quality</li>
              <li>• Sedentary lifestyle</li>
              <li>• Abnormal hormone levels</li>
              <li>• Severe menopausal symptoms</li>
            </ul>
          </div>
          
          <div className="bg-[#F8FAFC] rounded-xl p-4 border border-[#E2E8F0]">
            <h4 className="font-semibold text-[#334155] mb-2">Score Ranges</h4>
            <div className="flex items-center gap-4 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-[#10B981]" />
                <span className="text-[#64748B]">60-100: Good</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-[#F59E0B]" />
                <span className="text-[#64748B]">40-59: Moderate</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-[#DC2626]" />
                <span className="text-[#64748B]">0-39: Needs attention</span>
              </div>
            </div>
          </div>
          
          <p className="text-xs text-[#94A3B8] italic">
            This score is for informational purposes only and should not replace professional medical advice.
          </p>
        </div>
        
        <Button 
          onClick={onClose} 
          className="w-full mt-6 bg-gradient-to-r from-[#10B981] to-[#059669] hover:opacity-90 rounded-xl h-11"
        >
          Got it
        </Button>
      </motion.div>
    </div>
  );
};
